import { Box } from '@mantine/core'
import React from 'react'

export function CollapsibleCardContent({ children }: React.PropsWithChildren) {
  return <Box>{children}</Box>
}

CollapsibleCardContent.displayName = 'CollapsibleCard.Content'
